import React, { useEffect, useState } from "react";

const getInitials = (name, fallback = "?") => {
  if (!name) return fallback;

  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return fallback;
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

export default function UserAvatar({ src, name, className = "", fallback = "?" }) {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [src]);

  return (
    <div className={className} aria-label={name || "Hobbli collector"}>
      {src && !imageFailed ? (
        <img
          className="user-avatar__image"
          src={src}
          alt=""
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        getInitials(name, fallback)
      )}
    </div>
  );
}
